// Unpublished Work © 2025 Deere & Company.

import {Query} from '@tanstack/react-query';
import {showToast} from '../../Toast/hooks/useToast';
import {errorMessages, getErrorMessageToastType} from './errorMessages';

export const handleError = (error: Error, query: Query): void => {
    const errorMessage = query?.meta?.errorMessage;

    if (errorMessage) {
        showToast(getErrorMessageToastType(error, errorMessage));
    }
};

export const handleQueryError = (
    error: unknown,
    query: Query<unknown, unknown>,
): void => {
    if (query.meta?.onError) {
        query.meta.onError(error, query);
    }

    const queryKey = query.queryKey;
    let entityKey = Array.isArray(queryKey) ? queryKey[0] : queryKey;

    if (entityKey && entityKey.entity) {
        entityKey = entityKey.entity;
    }

    const handlerConfig = errorMessages[entityKey];

    if (handlerConfig && handlerConfig.customAction) {
        handlerConfig.customAction(error as Error, query as Query);
    }
};
